import { TypeOuiNon } from './type.oui.non';
import { TypeAdresseTEMPOST } from './type.adresse.tempost';
import { TypeEntite } from '../../../../models/typeEntite';


export class TypeFacturation {
  public libelle: TypeAdresseTEMPOST;
  public numBonCommande: string;
  public noServiceExecutant: string;
  public userChorus: TypeOuiNon;
  public typeEntite: TypeEntite;
  public identifiantAdressage: string;

  constructor() {
    this.libelle = new TypeAdresseTEMPOST();
    this.userChorus = new TypeOuiNon();
    this.numBonCommande = '';
    this.noServiceExecutant = '';
  }
}
